module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "v5-toast",
    class: ("" + _vm.position)
  }, [(_vm.text) ? _c('div', {
    staticClass: "v5-toast-content",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }) : _c('div', {
    staticClass: "v5-toast-content"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-241b5492","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@58fe/v5/src/components/toast/index.vue
// module id = 337
// module chunks = 0